import {
    Image,
    View
} from "react-native";
import {
    type BoardDirectorsCardProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    getFirstAndLastWord,
    useDebouncedDimensions
} from "../../utils";

const BoardDirectorsCard = ({
    profilePhotoURL,
    isPresident,
    fullName,
    position
}: BoardDirectorsCardProps) => {
    const {
        windowWidth
    } = useDebouncedDimensions();


    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const avatarText = () => {
        const {
            first,
            last
        } = getFirstAndLastWord(fullName);

        if (first && last) {
            return `${first[0]}${last[0]}`;
        }
        if (first) {
            return `${first[0]}`;
        }
        return "";
    };

    return <View
        style={[
            stylesheet.container,
            {
                width: isPresident ? windowWidth - spaces.spacingMd * 2 : windowWidth / 2 - spaces.spacingLg,
                backgroundColor: colors.content.container.mid,
                flexDirection: isPresident ? "row" : "column",
                marginTop: spaces.spacingLg,
                borderRadius: radiuses.sm,
                padding: spaces.spacingLg
            }
        ]}
    >
        {profilePhotoURL ?
            <Image
                source={{
                    uri: profilePhotoURL
                }}
                resizeMode="cover"
                style={{
                    borderRadius: radiuses.full,
                    height: isPresident ? 75 : 60,
                    width: isPresident ? 75 : 60
                }}
            />
            :
            <View
                style={[
                    stylesheet.avatarPlaceholder,
                    {
                        backgroundColor: colors.content.container.warning,
                        borderRadius: radiuses.lg * 3,
                        marginRight: spaces.spacingLg,
                        width: isPresident ? 75 : 60,
                        height: isPresident ? 75 : 60
                    }
                ]}
            >
                <Text
                    style={stylesheet.textCenter}
                    variant="headlineLargeSize"
                    color="warning"
                >
                    {avatarText().toUpperCase()}
                </Text>
            </View>
        }
        <View>
            {isPresident ?
                <View
                    style={[
                        stylesheet.presidentLabelContainer,
                        {
                            backgroundColor: colors.content.container.warning,
                            padding: spaces.spacingSm,
                            borderRadius: radiuses.sm
                        }
                    ]}
                >
                    <Text
                        style={stylesheet.textCenter}
                        variant="labelLargeSize"
                        color="warning"
                    >
                        {localize("president")}
                    </Text>
                </View>
                :
                null
            }
            <Text
                style={{
                    marginTop: spaces.spacingSm,
                    textAlign: isPresident ? "left" : "center"
                }}
                variant="titleMediumSize"
                color="high"
            >
                {fullName}
            </Text>
            <Text
                style={{
                    textAlign: isPresident ? "left" : "center",
                    marginTop: spaces.spacingSm
                }}
                variant="labelLargeSize"
                color="low"
            >
                {position}
            </Text>
        </View>
    </View>;
};
export default BoardDirectorsCard;
